import { render, staticRenderFns } from "./GalleryDashboardCardLoader.vue?vue&type=template&id=23870c8a"
import script from "./GalleryDashboardCardLoader.vue?vue&type=script&lang=ts"
export * from "./GalleryDashboardCardLoader.vue?vue&type=script&lang=ts"
import style0 from "./GalleryDashboardCardLoader.vue?vue&type=style&index=0&id=23870c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports